import { Box } from '@material-ui/core';
import { Currency } from '@nemuru-eng/js-api-client';
import { Dispatch, ReactNode, SetStateAction } from 'react';

import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import { CollapsableLiveSummary } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/components/CollapsableLiveSummary';
import { FinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingLiveSummaryData';
import { CustomAlert } from '@/components/shared/components/CustomAlert';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { useScreen } from '@/hooks/useScreen';

const LIVE_SUMMARY_GAP = 32;

interface EditStepWithLiveSummaryProps {
  children: ReactNode;
  previewErrorMessage?: string;
  showLiveSummary: boolean;
  setShowLiveSummary: Dispatch<SetStateAction<boolean>>;
  initialFormItem: AutomobileFormItem;
  initialFinancing: FinancingLiveSummaryData;
  currency: Currency;
  showVehicleSummary?: boolean;
  showFinancingSummary?: boolean;
  requiresFinancingReselection?: boolean;
}

export const EditStepWithLiveSummary = ({
  children,
  previewErrorMessage,
  showLiveSummary,
  setShowLiveSummary,
  initialFormItem,
  initialFinancing,
  currency,
  showVehicleSummary = true,
  showFinancingSummary = true,
  requiresFinancingReselection = false,
}: EditStepWithLiveSummaryProps) => {
  const { isMobile } = useScreen();

  return (
    <Box display="flex" alignItems="flex-start" gridGap={LIVE_SUMMARY_GAP}>
      <Box flex={1} minWidth={0}>
        <FlexColumn gridGap={16} style={{ width: '100%' }}>
          {children}
          {previewErrorMessage && (
            <CustomAlert
              severity="error"
              title={'AUTO_MODIFICATION_PREVIEW_ERROR'}
              description={<>{previewErrorMessage}</>}
            />
          )}
        </FlexColumn>
      </Box>
      {!isMobile && (
        <CollapsableLiveSummary
          showLiveSummary={showLiveSummary}
          setShowLiveSummary={setShowLiveSummary}
          initialFormItem={initialFormItem}
          initialFinancing={initialFinancing}
          currency={currency}
          showVehicleSummary={showVehicleSummary}
          showFinancingSummary={showFinancingSummary}
          requiresFinancingReselection={requiresFinancingReselection}
        />
      )}
    </Box>
  );
};
